module.exports = __webpack_public_path__ + "img/baiti_hangye.0b9a14f8.png";